function CreateGoogleDoc(props) {
  const { report_invoice, pdfoption } = props;
  report_invoice.report_dict.pdfoption = pdfoption;
  return null;
}

export default CreateGoogleDoc;